import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import TabPanel, { Tab, TabContent } from '../../../components/TabPanel';

import ClientSettingsTable from './ClientSettingsTable';
import ServiceStatusSettingsTable from './ServiceStatusSettingsTable';

import * as CommunicationActions from '../../../actions/communicationActions';
import * as CoreActions from '../../../actions/coreActions';

import classes from './AdvancedCommunicationsPage.module.css';

const DEFAULT_PAGE_SIZE = 25;

const AdvancedCommunicationsPage = ({
    clientSearchValue,
    clientSettings,
    clientSettingsLoading,
    clientSettingsMeta,
    companyId,
    fetchClientSettings,
    fetchServiceStatusSettings,
    match,
    serviceStatusSettings,
    serviceStatusSettingsLoading,
    serviceStatusSettingsMeta,
    setClientSettingsSearchValue,
    setProgressBarLoading,
    updateClientSettings,
    updateServiceStatusSettings,
    ...props
}) => {

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

    const [servicePage, setServicePage] = useState(0);
    const [servicePageSize, setServicePageSize] = useState(DEFAULT_PAGE_SIZE);

    useEffect(() => {
        const settings = [];
        setProgressBarLoading(true);

        settings.push(fetchClientSettings({limit: pageSize, page}));
        settings.push(fetchServiceStatusSettings({pageSize: servicePageSize, page: servicePage}));

        Promise.all(settings).then(() => {
            setProgressBarLoading(false);
        });
    }, [companyId]);

    useEffect(() => {
        const pageUpdate = page + 1;

        fetchClientSettings({limit: pageSize, page: pageUpdate});
    }, [page, pageSize]);

    useEffect(() => {
        const servicePageUpdate = servicePage + 1;

        fetchServiceStatusSettings({pageSize: servicePageSize, page: servicePageUpdate});
    }, [servicePage, servicePageSize]);

    useEffect(() => {
        fetchClientSettings({limit: pageSize, page, searchFilter: clientSearchValue});
    }, [clientSearchValue]);

    return (
        <TabPanel
            aria-label="Advanced Communications Settings"
            selectedTab={match.params.tab}
            classes={{
                root: classes.AdvancedCommunicationsPage
            }}
        >
            <Tab
                href="clients"
                title="Clients Settings"
            >
                <TabContent>
                    {
                        clientSettings &&
                        <div className={classes.advCommPanelContainer}>
                            <ClientSettingsTable
                                clientSettings={clientSettings}
                                clientSettingsMeta={clientSettingsMeta}
                                isLoading={clientSettingsLoading}
                                setClientSettingsSearch={setClientSettingsSearchValue}
                                onPageSet={setPage}
                                onPageSizeSet={setPageSize}
                                page={page}
                                pageSize={pageSize}
                                updateClientSettings={updateClientSettings}
                            />
                        </div>
                    }
                </TabContent>
            </Tab>
            <Tab
                href="status"
                title="Service Status Settings"
            >
                <TabContent>
                    {
                        serviceStatusSettings &&
                        <div className={classes.advCommPanelContainer}>
                            <ServiceStatusSettingsTable
                                serviceStatusSettings={serviceStatusSettings}
                                serviceStatusSettingsMeta={serviceStatusSettingsMeta}
                                isLoading={serviceStatusSettingsLoading}
                                onPageSet={setServicePage}
                                onPageSizeSet={setServicePageSize}
                                page={servicePage}
                                pageSize={servicePageSize}
                                updateServiceStatusSettings={updateServiceStatusSettings}
                            />
                        </div>
                    }
                </TabContent>
            </Tab>
        </TabPanel>
    );
};

AdvancedCommunicationsPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            tab: PropTypes.string
        }).isRequired
    }).isRequired
};

const mapStateToProps = state => {
    return {
        clientSearchValue:            state.communications.clientSearchValue,
        clientSettings:               state.communications.clientSettings,
        clientSettingsLoading:        state.communications.clientSettingsLoading,
        clientSettingsMeta:           state.communications.clientSettingsMeta,
        companyId:                    state.companyInfo.companyId,
        serviceStatusSettings:        state.communications.serviceStatusSettings,
        serviceStatusSettingsLoading: state.communications.serviceStatusSettingsLoading,
        serviceStatusSettingsMeta:    state.communications.serviceStatusSettingsMeta
    };
};

const mapDispatchToProps = {
    ...CommunicationActions,
    ...CoreActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdvancedCommunicationsPage));
